module.exports = __webpack_public_path__ + "static/media/CTLI_16-293w.9e4b96e1.webp";